import React, { useEffect, useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePrivate from '@afosto/auth-react/usePrivate';
import Grid from '@material-ui/core/Grid';
import Page from '@afosto/app-components-react/Page';
import TrafficThisMonthSection from './TrafficThisMonthSection';
import TransformationsThisMonthSection from './TransformationsThisMonthSection';
import Traffic30DaysSection from './Traffic30DaysSection';
import translations from './translations';
import UpcomingInvoiceSection from './UpcomingInvoiceSection';
import { proxy as proxyApi } from '@afosto/quicq/api/Proxy';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

const Dashboard = () => {
  usePrivate();
  const intl = useIntl();
  const [proxies, setProxies] = useState([]);
  const [isFetchingProxies, setIsFetchingProxies] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchProxies = async () => {
      setIsFetchingProxies(true);
      try {
        const response = await proxyApi.listQuicqProxies();
        const { data = [] } = response;

        if (isMounted) {
          setProxies(data);
        }
      } catch (error) {
        if (isMounted) {
          setProxies([]);
        }
      } finally {
        if (isMounted) {
          setIsFetchingProxies(true);
        }
      }
    };

    fetchProxies();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Page fullWidth title={intl.formatMessage(translations.title)}>
      <Grid container spacing={2}>
        {!isFetchingProxies && !proxies?.length > 0 && (
          <Grid item xs={12}>
            <Alert
              severity="info"
              action={
                <Button component={Link} to="/proxies" variant="contained" color="primary">
                  {intl.formatMessage(translations.noProxies.actions.proxiesPage)}
                </Button>
              }
            >
              <AlertTitle>{intl.formatMessage(translations.noProxies.title)}</AlertTitle>
              {intl.formatMessage(translations.noProxies.description)}
            </Alert>
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <TrafficThisMonthSection />
        </Grid>
        <Grid item xs={12} md={6}>
          <TransformationsThisMonthSection />
        </Grid>
        <Grid item xs={12}>
          <Traffic30DaysSection />
        </Grid>
        <Grid item xs={12}>
          <UpcomingInvoiceSection />
        </Grid>
      </Grid>
    </Page>
  );
};

export default Dashboard;
